import {LeaderboardRowData} from '../../../../shared/leaderboard_data/LeaderboardInterfaces'
import {ColonistMembershipProduct, ColonistMembershipType} from '../../../../shared/store/ColonistMembershipProduct'
import {UILeaderboardBaseTableRowView} from '../../../shared/scripts/ui_leaderboard/UILeaderboardBaseTableRowView.ts'
import {CountryCodes, ContinentCodes} from '@colonist/leaderboard-types'
import {clientI18n} from '../../../shared/scripts/ClientI18n'
import {UIProfileSettingsRegionChangeController} from '../../../shared/scripts/profile/UIProfileSettingsRegionChangeController'
import {TranslationObject} from '@colonist/i18n'
import {getImagePath, getLobbyImagePath} from '../../../shared/scripts/ui_utils/Utils'
import {ClientUserState} from '../../../shared/scripts/ClientUserState'
import {createDiv, createExternalImgIn} from '../../../shared/scripts/ui_utils/DomUtils'
import {getCountryOrContinentImageLink} from '../../../shared/scripts/ui_utils/CountryFlagUtils.ts'
import {createTooltipIn} from '../../../shared/scripts/ui_utils/TooltipUtils.ts'

export class UIDLeaderboardBaseTableRowView extends UILeaderboardBaseTableRowView {
    // eslint-disable-next-line class-methods-use-this
    protected getCountryOrContinentImage(continentCode: ContinentCodes | undefined, countryCode: CountryCodes | undefined, countryLeaderboardUrl: string | undefined): HTMLImageElement {
        const image: HTMLImageElement = document.createElement('img')

        image.src = getCountryOrContinentImageLink(countryCode, continentCode)
        image.classList.add('flag')
        image.onclick = () => undefined

        return image
    }

    // eslint-disable-next-line class-methods-use-this
    protected getMembershipImg(membershipType: ColonistMembershipType): HTMLImageElement {
        const image: HTMLImageElement = document.createElement('img')
        image.classList.add('membership_icon')
        image.id = 'store-href'
        const membershipProduct = ColonistMembershipProduct.getMembershipProduct(membershipType)
        image.src = getLobbyImagePath(membershipProduct.lobbyImage)
        return image
    }

    protected setDiscordNoClickStyles() {
        this.tdRank.classList.add('no-click')
        this.tdDivision.classList.add('no-click')
        this.tdUsername.classList.add('no-click')
    }

    protected setMyFlagIcon(rowData: LeaderboardRowData) {
        const neverChangedRegionManually = ClientUserState.userState?.regionUpdated == undefined
        const countryFlagImg = neverChangedRegionManually ? UIDLeaderboardBaseTableRowView.getDiscordIcon() : this.getCountryOrContinentImage(rowData.continentCode, rowData.countryCode, rowData.countryLeaderboardUrl)

        countryFlagImg.style.cursor = 'pointer'
        countryFlagImg.addEventListener('click', (mouseEvent: MouseEvent) => {
            mouseEvent.stopPropagation()
            UIProfileSettingsRegionChangeController.showChangeRegionPopup()
        })

        const countryOrContinentName = UILeaderboardBaseTableRowView.getCountryOrContinentName(rowData)
        const countryOrContinentNameString = clientI18n.t(countryOrContinentName.key, countryOrContinentName.options)
        const currentRegion: TranslationObject = {key: 'strings:leaderboardPage.changeRegion.currentRegion', options: {currentRegion: countryOrContinentNameString}}
        const chooseRegion: TranslationObject = {key: 'strings:leaderboardPage.changeRegion.chooseRegion'}

        createTooltipIn(countryFlagImg, neverChangedRegionManually ? chooseRegion : currentRegion, 'right')
        this.tdUsername.replaceChildren(rowData.username, countryFlagImg)
    }

    private static getDiscordIcon() {
        return createExternalImgIn(createDiv(), getImagePath('social_icon_discord_2.svg'), {key: 'strings:colonistCommon.utils.emptyString'}, 'flag')
    }
}
